import React from 'react';
import { TransifexManager } from './components/transifexManager/TransifexManager';
export const REACT_UTILITIES_TRANSIFEX_TAG = 'monocle-react-utilities';
const withTranslations = (
// eslint-disable-next-line @typescript-eslint/naming-convention
Component, displayName) => {
    const TranslatedComponent = props => {
        return (React.createElement(TransifexManager, { tag: REACT_UTILITIES_TRANSIFEX_TAG },
            React.createElement(Component, Object.assign({}, props))));
    };
    const componentName = 
    // eslint-disable-next-line i18next/no-literal-string
    displayName || Component.displayName || Component.name || 'Component';
    TranslatedComponent.displayName = componentName;
    return TranslatedComponent;
};
export { withTranslations };
